import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const previousPathnameAtom = atom('');

export function useTrackPreviousPathname() {
  const location = useLocation();
  const setPreviousPathname = useSetAtom(previousPathnameAtom);

  useEffect(() => {
    return () => {
      setPreviousPathname(location.pathname);
    };
  }, [location.pathname, setPreviousPathname]);
}

export function usePreviousPathname() {
  return useAtomValue(previousPathnameAtom);
}
